import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import GroupsMenuView from './View'
import { selectMenu, fetchGroups } from '../../../state/actions/patient-groups'

class GroupsMenuContainer extends Component {
  static propTypes = {
    fetchGroups: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.props.fetchGroups()
  }

  render() {
    return <GroupsMenuView {...this.props} />
  }
}

const mapStateToProps = ({ patientGroups }) => ({
  filters: patientGroups.filters,
  groups: patientGroups.groups,
  selected: patientGroups.selectedMenu,
})

const mapDispatchToProps = dispatch => ({
  onItemClick: (menuId, menuType, view) => {
    dispatch(selectMenu(menuId, menuType, view))
  },
  fetchGroups: () => {
    dispatch(fetchGroups())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GroupsMenuContainer)



// WEBPACK FOOTER //
// ./src/components/PatientGroups/GroupsMenu/index.js